// extracted by mini-css-extract-plugin
module.exports = {"panel":"Instruction_panel_MsqnW","stepNumber":"Instruction_stepNumber_2XDww typography_standard_3NYy8","instruction":"Instruction_instruction_UNkkq typography_standard_3NYy8"};